import SearchProjectsResults from './SearchProjectsResults.vue';

export default {
    SearchProjectsResults,
};
